<template>
  <div class="right-menu">
    <span v-if="loginType === 'qr-code'">
      <qr-code-form @back="loginType = null" />
    </span>
    <span v-else-if="loginType === 'account'">
      <login-form @back="loginType = null" />
    </span>
    <div v-else-if="loginType === null" class="login-menu">
      <span class="login-description">请选择登录方式</span>
      <a-card hoverable size="small" class="login-menu_item" @click="onAuthorizedLogin">
        <span class="login-menu_title">飞书授权登录<a-icon type="right" /> </span>
        <span class="login-menu_subtitle">点击后将跳转至飞书授权登录页</span>
      </a-card>
      <a-card hoverable size="small" class="login-menu_item" @click="loginType = 'qr-code'">
        <span class="login-menu_title">飞书扫码登录<a-icon type="right" /> </span>
        <span class="login-menu_subtitle">使用手机飞书扫码二维码登录</span>
      </a-card>
      <a-card hoverable size="small" class="login-menu_item" @click="loginType = 'account'">
        <span class="login-menu_title">LDAP账号登录<a-icon type="right" /> </span>
        <span class="login-menu_subtitle">使用Ldap账号密码登录</span>
      </a-card>
    </div>
  </div>
</template>
<script>
import LoginForm from '@/pages/login/components/LoginForm';
import QrCodeForm from '@/pages/login/components/QrCodeForm';
export default {
  components: { LoginForm, QrCodeForm },
  data() {
    return {
      loginType: null
    };
  },
  computed: {
    redirectUri() {
      if (this.$router.currentRoute.query.url) {
        return `${process.env.VUE_APP_FS_REDIRECT_URI}?url=${this.$router.currentRoute.query.url}`;
      }
      return process.env.VUE_APP_FS_REDIRECT_URI;
    }
  },
  methods: {
    onAuthorizedLogin() {
      const goto = `${process.env.VUE_APP_FS_BASE_URL}?client_id=${process.env.VUE_APP_FS_CLIENT_ID}&redirect_uri=${this.redirectUri}&response_type=code&state=STATE`;
      window.location.href = goto;
    }
  }
};
</script>
<style lang="less" scoped>
.right-menu {
  width: 100%;
}
.login-description {
  font-size: 16px;
  font-weight: 450;
}
.login-menu {
  width: 100%;
  float: right;
  margin: 0 auto;
}
.login-menu_title {
  /* font-size: 16px; */
  font-weight: bold;
  line-height: 16px;
  margin-bottom: 8px;
  display: block;
}

.login-menu_subtitle {
  color: rgba(0, 0, 0, 0.45);
}
.login-menu_item {
  margin: 12px 0;
}
/deep/.ant-card-small > .ant-card-body {
  background-color: rgba(207, 216, 220, 0.2);
  padding: 12px 16px;
}

.ant-card-body:hover {
  .login-menu_title {
    color: #1890ff;
  }
}
</style>
